import { render } from "./AddLeiturasPage.vue?vue&type=template&id=13eb6ebe"
import script from "./AddLeiturasPage.vue?vue&type=script&lang=js"
export * from "./AddLeiturasPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__